import { render } from "./첫화면.vue?vue&type=template&id=84386f6a"
import script from "./첫화면.vue?vue&type=script&lang=js"
export * from "./첫화면.vue?vue&type=script&lang=js"

import "./첫화면.vue?vue&type=style&index=0&id=84386f6a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__